<template>
  <Layout>
    <section class="section">
      <div class="container">
        <div class="important-deadlines">
          <h2>Important Deadlines</h2>

          <div class="row">
            <ul class="deadlines text-center">
              <li
                class="deadline col-md-4 animated icon-box"
                data-animation="fadeIn"
              >
                <img
                  class="icon"
                  src="/assets/img/icons/new-user.svg"
                  alt=""
                  width="50"
                />
                <h6>Registration, presenting companies</h6>
                <p>10 May 2021</p>
              </li>
              <li
                class="deadline col-md-4 animated icon-box"
                data-animation="fadeIn"
                data-delay="100"
              >
                <img
                  class="icon"
                  src="/assets/img/icons/new-user.svg"
                  alt=""
                  width="50"
                />
                <h6>Registration, Investors</h6>
                <p>10 May 2021</p>
              </li>
              <li
                class="deadline col-md-4 animated icon-box"
                data-animation="fadeIn"
                data-delay="200"
              >
                <span class="icon section-icon icon-seo-icons-05"></span>
                <h6>Presentations</h6>
                <p>1 June 2021</p>
              </li>
              <!-- <li class="deadline col-md-6 animated icon-box" data-animation="fadeIn" data-delay="100">
							<span class="icon section-icon icon-seo-icons-05"></span>
							<h6>Presentation</h6>
							<p>20 February 2020</p>
						</li> -->
              <!-- <li class="deadline col-md-6 animated icon-box" data-animation="fadeIn" data-delay="200">
							<span class="icon section-icon icon-shopping-25"></span>
							<h6>Shipping Form</h6>
							<p>20 February 2020</p>
						</li> -->
            </ul>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
  name: "ImportantDeadlines",
  components: { Layout },
};
</script>
